import React from 'react'

import _ from 'lodash'
import {Colors, Row, Info, Tabs, Tab, Popup, Alert, Button, IconButton, Modal, ModalHeader, H6, P} from '../UI/index.js'
import askToSaveChanges from '../UI/overlays/askToSaveChanges.js'
import {formSpacing, FormRow, FormStack, Input, FileUpload, Toggle, Select, TimePicker, MetricInput, ColorPicker, Option} from '../UI/forms/index.js'
import t from 'src/helpers/Languages.js'

const dayToLabel = {
    monday: 'M',
    tuesday: 'D',
    wednesday: 'W',
    thursday: 'D',
    friday: 'V',
    saturday: 'Z',
    sunday: 'Z'
}

export default class CarrierModal extends React.PureComponent {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            carrierName: '',
            settings: {},
            carrier: {},
            tempPlatformCarrierSettings: {}
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(carrierName, settings, platformCarriers, platform) {
        const {carriers} = this.props

        const carrier = carriers.find((carrier) => carrier?.name === carrierName)

        if (carrier) {
            if (carrier.type === 'partner') {
                settings.submitDays = settings.submitDays || {
                    monday: {enabled: true},
                    tuesday: {enabled: true},
                    wednesday: {enabled: true},
                    thursday: {enabled: true},
                    friday: {enabled: true},
                    saturday: {enabled: true},
                    sunday: {enabled: true}
                }
                settings.submitDayLowerPreference = settings.submitDayLowerPreference || false
            }

            this.setState({
                modalIsOpen: true,
                carrierName,
                settings,
                carrier,
                platformCarriers,
                platform
            })
        }
    }

    close() {
        this.setState(this.initialState)
    }

    onEnableCarrier() {
        const settings = {...this.state.settings}

        settings.enabled = true

        this.setState({settings})
    }

    onChangeCarrierValue(key, event, forAllPlatformCarriers = false, parser) {
        const value = typeof parser === 'function' ? parser(event.target.value) : event.target.value

        if (forAllPlatformCarriers) {
            const {tempPlatformCarrierSettings} = this.state

            this.state.platformCarriers.forEach((carrier) => {
                const settings = {...tempPlatformCarrierSettings?.[carrier.name] || {}}
                settings[key] = value
                tempPlatformCarrierSettings[carrier.name] = settings
            })

            this.setState({tempPlatformCarrierSettings})
        }

        const settings = {...this.state.settings}
        settings[key] = value
        this.setState({settings})
    }

    onChangeCarrierValues(key, event) {
        const settings = {...this.state.settings}
        settings[key] = event.target.values
        this.setState({settings})
    }

    onChangeFileUpload(key, fileName, value) {
        const settings = {...this.state.settings}
        settings[key] = value
        settings[`${key}FileName`] = fileName
        this.setState({settings})
    }

    onChangeDefaultLabelCarrier(event) {
        const settings = {...this.state.settings}
        settings.defaultLabelCarrier = event.target.value
        this.setState({settings})
    }

    onAddProductLabelCarrier() {
        const {carrier, settings} = this.state
        const selectedProducts = _.keys(settings.productLabelCarriers || {})
        const combinedProduct = _.keys(carrier.combinedProducts || {}).find((option) => !selectedProducts.includes(option))

        if (!combinedProduct) {
            return
        }

        const labelCarrier = _.keys(carrier.labelCarriers).find((name) => !carrier.labelCarriers[name].disabled)

        if (!labelCarrier) {
            return
        }

        const nextSettings = {...settings}
        nextSettings.productLabelCarriers = {...nextSettings.productLabelCarriers, [combinedProduct]: labelCarrier}
        this.setState({settings: nextSettings})
    }

    onChangeProductLabelCarrierProduct(currentCombinedProduct, event) {
        const nextCombinedProduct = event.target.value

        if (!nextCombinedProduct || nextCombinedProduct === currentCombinedProduct) {
            return
        }

        const settings = {...this.state.settings}
        const productLabelCarriers = {...settings.productLabelCarriers}

        productLabelCarriers[nextCombinedProduct] = productLabelCarriers[currentCombinedProduct]
        delete productLabelCarriers[currentCombinedProduct]

        settings.productLabelCarriers = productLabelCarriers
        this.setState({settings})
    }

    onChangeProductLabelCarrier(combinedProduct, event) {
        const settings = {...this.state.settings}
        settings.productLabelCarriers = {...settings.productLabelCarriers, [combinedProduct]: event.target.value}
        this.setState({settings})
    }

    onRemoveProductLabelCarrier(combinedProduct) {
        const settings = {...this.state.settings}
        settings.productLabelCarriers = _.omit(settings.productLabelCarriers, combinedProduct)
        this.setState({settings})
    }

    onChangeCarrierChecked(key, event) {
        const settings = {...this.state.settings}
        _.set(settings, key, event.target.checked)
        this.setState({settings})
    }

    onChangeUseDeliveryZones(event) {
        const settings = {...this.state.settings}
        settings.useCustomDeliveryZone = event.target.checked
        this.setState({settings})
    }

    onChangeWeight(event) {
        const settings = {...this.state.settings}
        settings.maxWeight = +event.target.value
        this.setState({settings})
    }

    onChangeDimension(key, event) {
        const settings = {...this.state.settings}

        settings.maxDimensions = settings.maxDimensions || {}
        settings.maxDimensions[key] = event.target.value

        this.setState({settings})
    }

    onChangeVolume(event) {
        const settings = {...this.state.settings}
        settings.maxVolume = event.target.value
        this.setState({settings})
    }

    onDisable(stayOpen = false) {
        const settings = {...this.state.settings}
        settings.enabled = false
        if (!stayOpen) {
            this.props.onSubmit(this.state.carrierName, settings)
            this.close()
        } else {
            this.setState({settings})
        }
    }

    onSubmit(_, stayOpen = false, enable = true, source = 'submit') {
        const {platform, settings, carrier, platformCarriers, carrierName} = this.state
        const {reseller} = this.props

        if (platform) {
            let openSavePopup = false
            let saveCurrentCarrier = false
            const otherCarriersToSave = []

            if (JSON.stringify(settings) !== JSON.stringify(reseller.settings.parcels.carriers[carrier.name])) {
                openSavePopup = true
                saveCurrentCarrier = true
            }

            platformCarriers.forEach((carrier) => {
                if (carrier.name === carrierName) {
                    return
                }

                const tempSettings = this.state.tempPlatformCarrierSettings?.[carrier.name]
                if (!tempSettings) {
                    return
                }

                if (JSON.stringify(tempSettings) !== JSON.stringify(reseller.settings.parcels.carriers[carrier.name])) {
                    openSavePopup = true
                    otherCarriersToSave.push(carrier.name)
                }
            })

            const callback = () => {
                if (saveCurrentCarrier) {
                    const settings = {...this.state.settings}
                    this.props.onSubmit(carrierName, settings)
                }

                otherCarriersToSave.forEach((carrierName) => {
                    this.props.onSubmit(carrierName, {...this.state.tempPlatformCarrierSettings[carrierName]})
                })

                this.close()
            }

            if (openSavePopup && source === 'close') {
                askToSaveChanges(this.popup).then((choice) => {
                    if (choice === 'save') {
                        callback()
                    } else if (choice === 'dontSave') {
                        this.close()
                    }
                })
            } else if (source === 'submit') {
                callback()
            } else {
                this.close()
            }
        } else {
            const settings = {...this.state.settings}
            settings.enabled = enable
            this.props.onSubmit(this.state.carrierName, settings)
            !stayOpen && this.close()
        }
    }

    getAvailableCombinedProducts(currentCombinedProduct = '') {
        const {carrier, settings} = this.state
        const selectedProducts = _.keys(settings.productLabelCarriers || {})

        return _.keys(carrier.combinedProducts || {}).filter((combinedProduct) => {
            return combinedProduct === currentCombinedProduct || !selectedProducts.includes(combinedProduct)
        })
    }

    renderLabelCarrierSelection(value, onChange) {
        const {carrier} = this.state

        return (
            <>
                <Select
                    style={{width: 180}}
                    value={value}
                    options={_.keys(carrier.labelCarriers).map((labelCarrier) => ({
                        value: labelCarrier,
                        title: carrier.labelCarriers[labelCarrier].displayName,
                        disabled: carrier.labelCarriers[labelCarrier].disabled
                    }))}
                    onChange={onChange}
                />

                <img alt='' src={carrier.labelCarriers?.[value]?.logo} style={{objectFit: 'contain', height: 32, width: 64}} />
            </>
        )
    }

    renderLabelCarrierRow(label, value, onChange, onRemove) {
        return (
            <Row key={label} style={{alignItems: 'center', columnGap: formSpacing.columnGap, marginBottom: 12}}>
                <P style={{flex: 1}}>{label}</P>

                {this.renderLabelCarrierSelection(value, onChange)}

                {onRemove ?
                    <IconButton onClick={onRemove}>
                        <i className='mdi mdi-delete' />
                    </IconButton> :
                    <div style={{width: 35}} />
                }
            </Row>
        )
    }

    renderProductLabelCarrierRow(combinedProduct, value) {
        return (
            <Row key={combinedProduct} style={{alignItems: 'center', columnGap: formSpacing.columnGap, marginBottom: 12}}>
                <Select
                    style={{flex: 1}}
                    placeholder={t('intrapostChooseShippingOption')}
                    value={combinedProduct}
                    options={this.getAvailableCombinedProducts(combinedProduct).map((product) => ({value: product, title: product}))}
                    onChange={this.onChangeProductLabelCarrierProduct.bind(this, combinedProduct)}
                />

                {this.renderLabelCarrierSelection(value, this.onChangeProductLabelCarrier.bind(this, combinedProduct))}

                <IconButton onClick={this.onRemoveProductLabelCarrier.bind(this, combinedProduct)}>
                    <i className='mdi mdi-delete' />
                </IconButton>
            </Row>
        )
    }

    render() {
        const {modalIsOpen, carrierName, settings, carrier, platformCarriers, platform} = this.state
        const {reseller} = this.props

        return (
            <Modal show={modalIsOpen} onClose={platform ? () => this.onSubmit(undefined, false, true, 'close') : this.close.bind(this)}>
                <ModalHeader
                    title={platform || `${carrier?.displayName || carrierName}${carrier.platform ? ` - ${carrier.platform}` : ''} ${settings.enabled ? 'instellingen' : 'activeren'}`}
                    onClose={platform ? () => this.onSubmit(undefined, false, true, 'close') : this.close.bind(this)}
                    style={{marginBottom: 0}}
                />

                {['DHL-onlineparcel', 'DPD-onlineparcel', 'PostNL-onlineparcel'].includes(carrierName) &&
                    <>
                        <H6 style={{marginBottom: 12}}>Koppeling</H6>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Public Key'
                                value={settings.publicKey}
                                onChange={(event) => this.onChangeCarrierValue('publicKey', event, true)}
                            />

                            <Input
                                label='Secret Key'
                                value={settings.secretKey}
                                type='password'
                                autoComplete='new-password'
                                onChange={(event) => this.onChangeCarrierValue('secretKey', event, true)}
                            />
                        </FormStack>

                        <Alert style={{marginBottom: 6}} variant='info'>Via dit platform kan geen referentie worden meegestuurd naar de vervoerder.</Alert>
                    </>
                }

                {platformCarriers?.length > 0 &&
                    <>
                        <H6 style={{marginBottom: 12, marginTop: 36}}>Vervoerders</H6>
                        <Tabs
                            style={{marginBottom: 30, height: 'fit-content'}}
                            value={carrier.name}
                            onChange={(e) => {
                                const value = e.target?.value
                                let tempSettings = this.state.tempPlatformCarrierSettings?.[value]
                                if (tempSettings && reseller.settings.parcels.carriers[value]) {
                                    tempSettings = {
                                        ...structuredClone(reseller.settings.parcels.carriers[value]),
                                        ...tempSettings
                                    }
                                }

                                this.setState({
                                    carrierName: value,
                                    tempPlatformCarrierSettings: {
                                        ...this.state.tempPlatformCarrierSettings,
                                        [carrier.name]: settings
                                    },
                                    settings: tempSettings ? tempSettings : reseller.settings.parcels.carriers[value] ? structuredClone(reseller.settings.parcels.carriers[value]) : {},
                                    carrier: platformCarriers.find((c) => c.name === value)
                                })
                            }}
                        >
                            {platformCarriers.map((c, index) => {
                                let isEnabled = false
                                if (reseller.settings.parcels.carriers[c.name]) {
                                    isEnabled = reseller.settings.parcels.carriers[c.name].enabled
                                }

                                if (this.state.tempPlatformCarrierSettings[c.name]) {
                                    isEnabled = this.state.tempPlatformCarrierSettings[c.name].enabled
                                }

                                if (carrierName === c.name) {
                                    isEnabled = settings.enabled
                                }

                                return (
                                    <Tab value={c.name} key={`${c.name}-${index}`}>
                                        <div style={{textAlign: 'center'}}>
                                            <img src={c.logo} width={48} height={48} style={{objectFit: 'contain', ...(!isEnabled && {filter: 'grayscale(100%)'})}} />
                                            <P>
                                                {(c.displayName || c.name).replace('-', '').replace(platform, '').trim()}
                                            </P>
                                        </div>
                                    </Tab>
                                )
                            })}
                        </Tabs>
                    </>
                }

                {['DHL-onlineparcel', 'DPD-onlineparcel', 'PostNL-onlineparcel'].includes(carrierName) && !settings.enabled &&
                    <Button onClick={this.onEnableCarrier.bind(this)}>
                        Activeer
                    </Button>
                }

                {(['Cycloon', 'DHL', 'DHL-europlus', 'GLS', 'Intrapost', 'Peddler', 'PostNL', 'Skynet', 'sparqle', 'PostNL-MSG', 'DHL-MSG', 'Bpost-QLS', 'PostNL-QLS', 'DHL-QLS', 'DPD-QLS'].includes(carrierName)) &&
                    <>
                        <H6 style={{marginBottom: 12, marginTop: 36}}>Koppeling</H6>
                    </>
                }

                {carrierName === 'Cycloon' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='API Key vervoerders account'
                            info='Vul hier de API Key van je vervoerders bij Cycloon.'
                            value={settings.carrierApiKey}
                            onChange={this.onChangeCarrierValue.bind(this, 'carrierApiKey')}
                        />
                    </FormStack>
                }

                {(carrierName === 'DHL' || carrierName === 'DHL-europlus') &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Klantnummer'
                            value={settings.accountId}
                            onChange={this.onChangeCarrierValue.bind(this, 'accountId')}
                        />

                        <Input
                            label='Gebruikers ID'
                            value={settings.userId}
                            onChange={this.onChangeCarrierValue.bind(this, 'userId')}
                        />

                        <Input
                            label='API Key'
                            value={settings.apiKey}
                            onChange={this.onChangeCarrierValue.bind(this, 'apiKey')}
                        />
                    </FormStack>
                }

                {carrierName === 'GLS' &&
                    <>
                        <Alert style={{marginBottom: 6}} variant='info'>Om status updates van zendingen te ontvangen moeten er een aanvraag worden ingediend bij GLS. Stuur hiervoor een bericht naar info@veloyd.nl en vermeld hierin je GLS gebruikersnaam.</Alert>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Klantnummer'
                                value={settings.customerNumber}
                                onChange={this.onChangeCarrierValue.bind(this, 'customerNumber')}
                            />

                            <Input
                                label='Gebruikersnaam'
                                value={settings.username}
                                onChange={this.onChangeCarrierValue.bind(this, 'username')}
                            />

                            <Input
                                label='Wachtwoord'
                                type='password'
                                autoComplete='new-password'
                                value={settings.password}
                                onChange={this.onChangeCarrierValue.bind(this, 'password')}
                            />
                        </FormStack>
                    </>
                }

                {carrierName === 'Peddler' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Gebruik nieuwe API versie (Enterprise Shipping Service)'
                            checked={settings.useESS}
                            onChange={this.onChangeCarrierChecked.bind(this, 'useESS')}
                        />

                        {settings.useESS ?
                            <>
                                <Input
                                    label='Client Id'
                                    value={settings.clientId}
                                    onChange={this.onChangeCarrierValue.bind(this, 'clientId')}
                                />

                                <Input
                                    label='Client Secret'
                                    type='password'
                                    value={settings.clientSecret}
                                    onChange={this.onChangeCarrierValue.bind(this, 'clientSecret')}
                                />

                                <Input
                                    label='Carrier Id'
                                    value={settings.carrierId}
                                    onChange={this.onChangeCarrierValue.bind(this, 'carrierId')}
                                />

                                <Select
                                    label='Delivery Contents Type'
                                    value={settings.deliveryContentsType}
                                    options={[
                                        {value: 'GOODS', title: 'GOODS'},
                                        {value: 'FOOD', title: 'FOOD'},
                                        {value: 'ALCOHOL', title: 'ALCOHOL'},
                                        {value: 'BOOKS', title: 'BOOKS'}
                                    ]}
                                    onChange={this.onChangeCarrierValue.bind(this, 'deliveryContentsType')}
                                />
                            </> :
                            <>
                                <Input
                                    label='Gebruiker Id'
                                    value={settings.userId}
                                    onChange={this.onChangeCarrierValue.bind(this, 'userId')}
                                />

                                <Input
                                    label='Applicatie Id'
                                    value={settings.applicationId}
                                    onChange={this.onChangeCarrierValue.bind(this, 'applicationId')}
                                />

                                <Input
                                    label='Winkel Id'
                                    value={settings.storeId}
                                    onChange={this.onChangeCarrierValue.bind(this, 'storeId')}
                                />

                                <FileUpload
                                    accept='.rsa'
                                    label='RSA key'
                                    fileName={settings.rsaKeyFileName}
                                    onChange={this.onChangeFileUpload.bind(this, 'rsaKey')}
                                />

                            </>
                        }

                    </FormStack>
                }

                {carrierName === 'PostNL' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Klantnummer'
                            value={settings.customerNumber}
                            onChange={this.onChangeCarrierValue.bind(this, 'customerNumber')}
                        />

                        <Input
                            label='Klantcode'
                            value={settings.customerCode}
                            onChange={this.onChangeCarrierValue.bind(this, 'customerCode')}
                        />

                        <Input
                            label='Klantcode internationaal'
                            value={settings.customerCodeInt}
                            onChange={this.onChangeCarrierValue.bind(this, 'customerCodeInt')}
                        />

                        <Input
                            label='API Key'
                            value={settings.apiKey}
                            onChange={this.onChangeCarrierValue.bind(this, 'apiKey')}
                        />
                    </FormStack>
                }

                {carrierName === 'Skynet' &&
                    <>
                        <Alert style={{marginBottom: 6}} variant='info'>Om status updates van zendingen te ontvangen moeten er een aanvraag worden ingediend bij Skynet. Stuur hiervoor een bericht naar info@veloyd.nl en vermeld hierin je Skynet gebruikersnaam.</Alert>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Gebruikersnaam'
                                value={settings.username}
                                onChange={this.onChangeCarrierValue.bind(this, 'username')}
                            />

                            <Input
                                label='Wachtwoord'
                                type='password'
                                autoComplete='new-password'
                                value={settings.password}
                                onChange={this.onChangeCarrierValue.bind(this, 'password')}
                            />

                            <Input
                                label='API Key'
                                value={settings.apiKey}
                                onChange={this.onChangeCarrierValue.bind(this, 'apiKey')}
                            />
                        </FormStack>
                    </>
                }

                {(carrierName === 'PostNL-MSG' || carrierName === 'DHL-MSG') &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Gebruikersnaam'
                            value={settings.username}
                            onChange={this.onChangeCarrierValue.bind(this, 'username')}
                        />

                        <Input
                            label='Wachtwoord'
                            type='password'
                            autoComplete='new-password'
                            value={settings.password}
                            onChange={this.onChangeCarrierValue.bind(this, 'password')}
                        />

                        <Input
                            label='Klantnaam in Monta'
                            value={settings.originName}
                            onChange={this.onChangeCarrierValue.bind(this, 'originName')}
                        />
                    </FormStack>
                }

                {carrierName === 'Packs' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='Gebruikersnaam'
                            value={settings.username}
                            onChange={this.onChangeCarrierValue.bind(this, 'username')}
                        />

                        <Input
                            label='Wachtwoord'
                            type='password'
                            autoComplete='new-password'
                            value={settings.password}
                            onChange={this.onChangeCarrierValue.bind(this, 'password')}
                        />
                    </FormStack>
                }

                {carrierName === 'Intrapost' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='API Key'
                            info='De API Key is te vinden op de documentatiepagina van Intrapost (api.intrapost.nl/documentation) na het inloggen.'
                            type='password'
                            autoComplete='new-password'
                            value={settings.apiKey}
                            onChange={this.onChangeCarrierValue.bind(this, 'apiKey')}
                        />

                        <Input
                            label='Kostenplaats (AccountNumber)'
                            value={settings.accountNumber}
                            onChange={this.onChangeCarrierValue.bind(this, 'accountNumber')}
                        />
                    </FormStack>
                }

                {carrierName === 'sparqle' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Input
                            label='API Key'
                            type='password'
                            autoComplete='new-password'
                            value={settings.apiKey}
                            onChange={this.onChangeCarrierValue.bind(this, 'apiKey')}
                        />

                        <Input
                            label='Location ID'
                            value={settings.locationId}
                            onChange={this.onChangeCarrierValue.bind(this, 'locationId')}
                        />
                    </FormStack>
                }

                {(carrierName === 'Bpost-QLS' || carrierName === 'PostNL-QLS' || carrierName === 'DHL-QLS' || carrierName === 'DPD-QLS') &&
                    <>
                        {carrierName === 'DHL-QLS' &&
                            <Alert style={{marginBottom: 6}} variant='info'>Voor zendingen naar Duitsland kan geen afzender adres worden meegestuurd.</Alert>
                        }

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                label='Gebruikersnaam'
                                value={settings.username}
                                onChange={this.onChangeCarrierValue.bind(this, 'username')}
                            />

                            <Input
                                label='Wachtwoord'
                                type='password'
                                autoComplete='new-password'
                                value={settings.password}
                                onChange={this.onChangeCarrierValue.bind(this, 'password')}
                            />

                            <Input
                                label='Bedrijfs ID'
                                value={settings.companyId}
                                onChange={this.onChangeCarrierValue.bind(this, 'companyId')}
                            />

                            <Input
                                label='Merk ID'
                                value={settings.brandId}
                                onChange={this.onChangeCarrierValue.bind(this, 'brandId')}
                            />
                        </FormStack>
                    </>
                }

                {['Cycloon', 'DHL', 'GLS', 'Intrapost', 'Peddler', 'PostNL', 'Skynet', 'Packs', 'sparqle'].includes(carrierName) &&
                    <>
                        <br />
                        <br />
                    </>
                }

                <H6 style={{marginBottom: 12, marginTop: 36}}>Bezorgrestricties</H6>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    {carrier?.type === 'partner' && (
                        <>
                            <FormRow style={{alignItems: 'center'}}>
                                <div style={{display: 'flex', flex: 1}}>
                                    <P>Aanlever dagen</P>
                                    <Info style={{marginLeft: 6}} color={Colors.buttonSolid} text={`Selecteer hier op welke dagen zendingen bij ${carrier.displayName || carrier.name} worden aangeleverd. De rit voor uitvoering wordt de dag na aanlevering in de planning gezet.`} />
                                </div>

                                <div style={{display: 'flex', flex: 1, justifyContent: 'flex-end', columnGap: formSpacing.columnGap}}>
                                    {_.keys(dayToLabel).filter((day) => settings.submitDays[day]).map((day) => {
                                        return (
                                            <Option
                                                key={day}
                                                label={dayToLabel[day]}
                                                checked={settings.submitDays[day].enabled}
                                                disabled={!carrier.openingHours[day].open}
                                                onChange={this.onChangeCarrierChecked.bind(this, `submitDays.${day}.enabled`)}
                                            />
                                        )
                                    })}
                                </div>
                            </FormRow>

                            {_.keys(settings.submitDays).some((d) => !settings.submitDays[d].enabled) &&
                                <Toggle
                                    label='Lagere voorkeur bij aanmelden op een dag zonder aanlevering'
                                    info={`Geef ${carrier.name} een lagere voorkeur op dagen waarop er niet kan worden aangeleverd.`}
                                    checked={settings.submitDayLowerPreference}
                                    onChange={this.onChangeCarrierChecked.bind(this, 'submitDayLowerPreference')}
                                />
                            }
                        </>
                    )}

                    {carrierName !== reseller.name ?
                        <>
                            <Toggle
                                label='Gebruik eigen bezorggebied'
                                checked={settings.useCustomDeliveryZone}
                                onChange={this.onChangeUseDeliveryZones.bind(this)}
                                disabled={platform && !settings.enabled}
                            />

                            {settings.useCustomDeliveryZone &&
                                <Select
                                    copy
                                    label='Bezorggebieden'
                                    options={reseller.settings.deliveryZones.map((area) => {
                                        return {value: area.id, title: area.name}
                                    })}
                                    values={settings.deliveryZones || []}
                                    onChange={this.onChangeCarrierValues.bind(this, 'deliveryZones')}
                                    disabled={platform && !settings.enabled}
                                />
                            }
                        </> :
                        <>
                            <Select
                                copy
                                label='Bezorggebieden'
                                options={reseller.settings.deliveryZones.map((area) => {
                                    return {value: area.id, title: area.name}
                                })}
                                values={settings.deliveryZones || []}
                                onChange={this.onChangeCarrierValues.bind(this, 'deliveryZones')}
                                disabled={platform && !settings.enabled}
                            />

                            <Input
                                label='(Aanvullende) postcodes'
                                info='De postcodes waar je zendingen gaat bezorgen. Gebruik een komma om postcodes te scheiden en een streepje om een reeks te noteren. Postcodes kunnen mét of zónder letters gekozen worden. Bijvoorbeeld: 1000-2000, 3000, 4000AA-4000ZZ'
                                value={settings.postalCodes}
                                onChange={this.onChangeCarrierValue.bind(this, 'postalCodes')}
                                disabled={platform && !settings.enabled}
                            />
                        </>
                    }

                    <MetricInput
                        label='Max gewicht (kg)'
                        value={settings.maxWeight}
                        divisionFactor={1000}
                        onChange={(event) => this.onChangeWeight(event)}
                        max={carrier?.maxWeight}
                        placeholder={carrier?.maxWeight}
                        append='kg'
                        disabled={platform && !settings.enabled}
                    />
                </FormStack>

                <P>Max dimensies</P>
                <br />
                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <FormRow>
                        <MetricInput
                            label='Lengte'
                            value={settings.maxDimensions?.length}
                            divisionFactor={10}
                            onChange={this.onChangeDimension.bind(this, 'length')}
                            max={carrier?.maxDimensions?.length}
                            placeholder={carrier?.maxDimensions?.length}
                            append='cm'
                            disabled={platform && !settings.enabled}
                        />
                        <MetricInput
                            label='Breedte'
                            value={settings.maxDimensions?.width}
                            divisionFactor={10}
                            onChange={this.onChangeDimension.bind(this, 'width')}
                            max={carrier?.maxDimensions?.width}
                            placeholder={carrier?.maxDimensions?.width}
                            append='cm'
                            disabled={platform && !settings.enabled}
                        />
                        <MetricInput
                            label='Hoogte'
                            value={settings.maxDimensions?.height}
                            divisionFactor={10}
                            onChange={this.onChangeDimension.bind(this, 'height')}
                            max={carrier?.maxDimensions?.height}
                            placeholder={carrier?.maxDimensions?.height}
                            append='cm'
                            disabled={platform && !settings.enabled}
                        />
                    </FormRow>

                    <MetricInput
                        label='Max inhoud'
                        value={settings.maxVolume}
                        onChange={this.onChangeCarrierValue.bind(this, 'maxVolume')}
                        max={carrier?.maxVolume}
                        placeholder={carrier?.maxVolume}
                        append='dm³'
                        disabled={platform && !settings.enabled}
                    />
                </FormStack>

                {carrierName === reseller.name &&
                    <>
                        <H6 style={{marginBottom: 12, marginTop: 36}}>Bezorgopties</H6>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            {!reseller.isShop &&
                                <Input
                                    label='Aantal bezorgpogingen'
                                    type='number'
                                    min={1}
                                    max={99}
                                    value={settings.nrOfDeliveries}
                                    onChange={(event) => this.onChangeCarrierValue('nrOfDeliveries', event, false, parseInt)}
                                />
                            }

                            {!reseller.isShop &&
                                <Input
                                    type='number'
                                    label='Bewaartijd'
                                    min={0}
                                    max={365}
                                    info='Hoeveel dagen blijft de zending in bewaring na de laatste bezorgpoging. Vul 0 in om de zending meteen retour te sturen.'
                                    value={settings.nrOfDaysBeforeRetour}
                                    onChange={(event) => this.onChangeCarrierValue('nrOfDaysBeforeRetour', event, false, parseInt)}
                                />
                            }

                            {reseller.settings.parcels.products['Same Day'] && reseller.settings.parcels.products['Same Day'][carrierName] &&
                                <>
                                    <Toggle
                                        label='Same Day naar bedrijfsadressen'
                                        checked={settings.sameDayBusiness}
                                        onChange={this.onChangeCarrierChecked.bind(this, 'sameDayBusiness')}
                                    />

                                    {settings.sameDayBusiness &&
                                        <div style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap}}>
                                            <P style={{flex: 1}}>Same Day bedrijfsadres bezorgtijdvak</P>

                                            <TimePicker
                                                label='Van'
                                                style={{width: 130}}
                                                value={settings.sameDayBusinessFrom || ''}
                                                onChange={this.onChangeCarrierValue.bind(this, 'sameDayBusinessFrom')}
                                            />

                                            <TimePicker
                                                label='Tot'
                                                style={{width: 130}}
                                                value={settings.sameDayBusinessTill || ''}
                                                onChange={this.onChangeCarrierValue.bind(this, 'sameDayBusinessTill')}
                                            />
                                        </div>
                                    }

                                    <div style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap}}>
                                        <P style={{flex: 1}}>Same Day bezorgtijdvak</P>

                                        <TimePicker
                                            label='Van'
                                            style={{width: 130}}
                                            value={settings.sameDayFrom || ''}
                                            onChange={this.onChangeCarrierValue.bind(this, 'sameDayFrom')}
                                        />

                                        <TimePicker
                                            label='Tot'
                                            style={{width: 130}}
                                            value={settings.sameDayTill || ''}
                                            onChange={this.onChangeCarrierValue.bind(this, 'sameDayTill')}
                                        />
                                    </div>
                                </>
                            }

                            <div style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap}}>
                                <P style={{flex: 1}}>Next Day bezorgtijdvak</P>

                                <TimePicker
                                    label='Van'
                                    style={{width: 130}}
                                    value={settings.nextDayFrom || ''}
                                    onChange={this.onChangeCarrierValue.bind(this, 'nextDayFrom')}
                                />

                                <TimePicker
                                    label='Tot'
                                    style={{width: 130}}
                                    value={settings.nextDayTill || ''}
                                    onChange={this.onChangeCarrierValue.bind(this, 'nextDayTill')}
                                />
                            </div>

                            <div style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap}}>
                                <P style={{flex: 1}}>Next Day bedrijfsadres bezorgtijdvak</P>

                                <TimePicker
                                    label='Van'
                                    style={{width: 130}}
                                    value={settings.businessFrom || ''}
                                    onChange={this.onChangeCarrierValue.bind(this, 'businessFrom')}
                                />

                                <TimePicker
                                    label='Tot'
                                    style={{width: 130}}
                                    value={settings.businessTill || ''}
                                    onChange={this.onChangeCarrierValue.bind(this, 'businessTill')}
                                />
                            </div>

                            {!reseller.isShop &&
                                <Toggle
                                    label='Standaard met handtekening'
                                    info='Voor alle zendingen wordt een handtekening gevraagd bij het bezorgen ongeacht of de optie Handtekening voor ontvangst is aangevinkt.'
                                    checked={settings.defaultSigned}
                                    onChange={this.onChangeCarrierChecked.bind(this, 'defaultSigned')}
                                />
                            }
                        </FormStack>
                    </>
                }

                <H6 style={{marginBottom: 12, marginTop: 36}}>Overig</H6>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    {carrierName === 'PostNL-onlineparcel' &&
                        <Toggle
                            label='Aangetekend aanmelden als Handtekening + Niet bij buren'
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                            disabled={platform && !settings.enabled}
                        />
                    }

                    <div style={{display: 'flex', alignItems: 'center', gap: formSpacing.section}}>
                        <Toggle
                            label='Kleur tonen bij scannen'
                            info='Bij meerdere vervoerders met hetzelfde logo kan het handig zijn om tijdens het scannen een kleur te zien voor snelle herkenning'
                            checked={settings.useCustomScanColor}
                            onChange={this.onChangeCarrierChecked.bind(this, 'useCustomScanColor')}
                            disabled={platform && !settings.enabled}
                        />

                        {settings.useCustomScanColor &&
                            <div style={{width: '50%', display: 'flex', alignItems: 'center', gap: formSpacing.section}}>
                                <ColorPicker
                                    value={settings.customScanColor}
                                    colors={Colors.routeColors}
                                    onChange={this.onChangeCarrierValue.bind(this, 'customScanColor')}
                                    disabled={platform && !settings.enabled}
                                />

                                <P
                                    style={{
                                        height: 36,
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 4,
                                        backgroundColor: settings.customScanColor || '',
                                        color: Colors.isDarkBackground(settings.customScanColor || '') ? 'white' : 'black'
                                    }}
                                >
                                    {carrier.displayName || carrier.name}
                                </P>
                            </div>
                        }
                    </div>

                    {['DHL-onlineparcel', 'DPD-onlineparcel', 'PostNL-onlineparcel', 'Intrapost'].includes(carrierName) &&
                        <Toggle
                            label={`Retouren via ${reseller.settings?.accountName || reseller.name}`}
                            info={`Het adres van ${reseller.settings?.accountName || reseller.name} wordt gebruikt als afzender op de verzendlabels.`}
                            checked={settings.returnsViaReseller}
                            onChange={this.onChangeCarrierChecked.bind(this, 'returnsViaReseller')}
                            disabled={platform && !settings.enabled}
                        />
                    }
                </FormStack>

                {carrierName === 'Intrapost' &&
                    <>
                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Select
                                label={t('intrapostEnvelopeRegisterAs')}
                                info={t('intrapostEnvelopeNoTrackTraceInfo')}
                                options={[
                                    {value: 'Standard', title: t('intrapostEnvelopeProductStandard')},
                                    {value: 'FixedDays', title: t('intrapostEnvelopeProductFixedDays')}
                                ]}
                                value={settings.envelopeProduct || 'Standard'}
                                onChange={this.onChangeCarrierValue.bind(this, 'envelopeProduct')}
                            />
                        </FormStack>

                        <H6 style={{marginBottom: 12, marginTop: 36}}>{t('intrapostCustomerLogosTitle')}</H6>

                        <P>{t('intrapostCustomerLogosInfo')}</P>
                        <br />

                        {this.renderLabelCarrierRow(t('intrapostDefaultLogo'), settings.defaultLabelCarrier || 'Intrapost', this.onChangeDefaultLabelCarrier.bind(this))}

                        {_.keys(settings.productLabelCarriers || {}).map((combinedProduct) => {
                            return this.renderProductLabelCarrierRow(
                                combinedProduct,
                                settings.productLabelCarriers[combinedProduct]
                            )
                        })}

                        {this.getAvailableCombinedProducts().length > 0 &&
                            <Button
                                style={{marginTop: 12, marginBottom: 24}}
                                variant='outline-white'
                                icon='mdi mdi-plus'
                                label={t('intrapostAddShippingOption')}
                                onClick={this.onAddProductLabelCarrier.bind(this)}
                            />
                        }
                    </>
                }

                {carrierName === 'PostNL-onlineparcel' &&
                    <Alert style={{marginBottom: 6}} variant='info'>Verzendoptie Niet bij buren wordt bij deze vervoerder aangemeld als Alleen huisadres + Handtekening voor ontvangst.</Alert>
                }

                {carrierName === 'Cycloon' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Select
                            label='Aangetekend aanmelden als'
                            options={[
                                {value: '', title: 'Handtekening voor ontvangst + Niet bij buren'},
                                {value: '5', title: 'Aangetekend pakket'}
                            ]}
                            value={settings.signedParcelProduct || ''}
                            onChange={this.onChangeCarrierValue.bind(this, 'signedParcelProduct')}
                        />

                        <Toggle
                            label='Lagere voorkeur op vrijdag'
                            info='Cycloon krijgt een lagere voorkeur dan andere vervoerders voor pakketten die worden aangemeld op vrijdag, dit voorkomt vertraging van een pakket omdat Cycloon op zaterdag niet bezorgd. Deze instelling kan op klant niveau worden overschreven.'
                            checked={settings.noParcelsOnFriday}
                            onChange={this.onChangeCarrierChecked.bind(this, 'noParcelsOnFriday')}
                        />

                        <Toggle
                            label='Alleen Cycloon bezorgingen per fiets'
                            info='Cycloon is alleen beschikbaar voor zendingen die op de fiets worden bezorgd. Deze instelling kan op klant niveau worden overschreven.'
                            checked={settings.deliveredByBikeOnly}
                            onChange={this.onChangeCarrierChecked.bind(this, 'deliveredByBikeOnly')}
                        />
                    </FormStack>
                }

                {carrierName === 'DHL' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Aangetekend optie activeren'
                            info={'De optie \'Aangetekend\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                        />

                        <Toggle
                            label='Aangetekende brief optie activeren'
                            info={'De optie \'Aangetekende brief\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedLetterEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedLetterEnabled')}
                        />

                        <Toggle
                            label='Bedrijfsadressen via DHL Europlus'
                            info='Zendingen naar bedrijfsadressen worden verstuurd via het DHL Europlus netwerk. Deze instelling kan op klant niveau worden overschreven.'
                            checked={settings.europlusForBusinesAddress}
                            onChange={this.onChangeCarrierChecked.bind(this, 'europlusForBusinesAddress')}
                        />

                        {!reseller.isShop &&
                            <Toggle
                                label={`Retouren via ${reseller.settings?.accountName || reseller.name}`}
                                info={`Het adres van ${reseller.settings?.accountName || reseller.name} wordt gebruikt als afzender op de verzendlabels.`}
                                checked={settings.returnsViaReseller}
                                onChange={this.onChangeCarrierChecked.bind(this, 'returnsViaReseller')}
                            />
                        }
                    </FormStack>
                }

                {carrierName === 'DHL-europlus' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Aangetekend optie activeren'
                            info={'De optie \'Aangetekend\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                        />

                        {!reseller.isShop &&
                            <Toggle
                                label={`Retouren via ${reseller.settings?.accountName || reseller.name}`}
                                info={`Het adres van ${reseller.settings?.accountName || reseller.name} wordt gebruikt als afzender op de verzendlabels.`}
                                checked={settings.returnsViaReseller}
                                onChange={this.onChangeCarrierChecked.bind(this, 'returnsViaReseller')}
                            />
                        }
                    </FormStack>
                }

                {carrierName === 'DHL-MSG' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Aangetekend optie activeren'
                            info={'De optie \'Aangetekend\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                        />

                        <Toggle
                            label='Aangetekende brief optie activeren'
                            info={'De optie \'Aangetekende brief\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedLetterEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedLetterEnabled')}
                        />

                        <Input
                            label='Standaard product SKU'
                            info='Vul hier de SKU code in zoals in het Monta account is gedefineerd.'
                            value={settings.defaultProductSKU}
                            onChange={this.onChangeCarrierValue.bind(this, 'defaultProductSKU')}
                        />

                        <Input
                            label='Brievenbuspakket product SKU'
                            info='Vul hier de SKU code in zoals in het Monta account is gedefineerd.'
                            value={settings.mailboxProductSKU}
                            onChange={this.onChangeCarrierValue.bind(this, 'mailboxProductSKU')}
                        />
                    </FormStack>
                }

                {['DHL-MSG', 'DHL', 'Cycloon'].includes(carrierName) &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Lagere voorkeur voor bedrijfsadres'
                            info={`${carrierName} krijgt een lagere voorkeur dan andere vervoerders voor pakketten die worden bezorgd op een bedrijfsadres. Deze instelling kan op klant niveau worden overschreven.`}
                            checked={settings.noParcelsForBusinessAddress}
                            onChange={this.onChangeCarrierChecked.bind(this, 'noParcelsForBusinessAddress')}
                        />
                    </FormStack>
                }

                {carrierName === 'DHL' &&
                    <Alert style={{marginBottom: 6}} variant='info'>De verzendoptie Spoed kan voor DHL alleen gebruikt worden als de zending naar een bedrijfsadres gaat.
                    </Alert>
                }

                {carrierName === 'DHL-europlus' &&
                    <>
                        <Alert style={{marginBottom: 6}} variant='info'>
                            Deze vervoerder kan alleen gekozen worden wanneer een adres is aangemerkt als bedrijfsadres.
                        </Alert>

                        <Alert style={{marginBottom: 6}} variant='info'>
                            Deze vervoerder levert standaard met handtekening en niet bij buren. Deze opties kunnen gekozen worden maar zullen niet worden aangemeld bij de vervoerder.
                        </Alert>
                    </>
                }

                {carrierName === 'DPD-onlineparcel' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Zaterdag bezorging'
                            info='Zendingen die op vrijdag worden aangemeld worden op zaterdag bezorgd. Deze instelling kan op klant niveau worden overschreven.'
                            checked={settings.saturdayDelivery}
                            onChange={this.onChangeCarrierChecked.bind(this, 'saturdayDelivery')}
                            disabled={platform && !settings.enabled}
                        />
                    </FormStack>
                }

                {carrierName === 'DPD-onlineparcel' &&
                    <Alert style={{marginBottom: 6}} variant='info'>De verzendopties Handtekening voor ontvangst en Verzekerd worden niet apart aangemeld, maar vallen onder de standaard zending van DPD.</Alert>
                }

                {carrierName === 'Peddler' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Toon sorteercodes op label'
                            checked={settings.sortCodesOnLabel}
                            onChange={this.onChangeCarrierChecked.bind(this, 'sortCodesOnLabel')}
                        />

                    </FormStack>
                }

                {carrierName === 'PostNL' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Select
                            label='Standaard emailadres Track & Trace emails'
                            info='Voor PostNL zendingen is het meesturen van een emailadres verplicht. Als een zending geen emailadres heeft wordt de gekozen optie gebruikt.'
                            allowEmpty
                            options={[
                                {value: 'resellerEmail', title: reseller.settings.companyAddress.email},
                                {value: 'customerEmail', title: 'Emailadres klant'},
                                {value: 'custom', title: 'Anders'}
                            ]}
                            value={settings.defaultTTEmailAddress}
                            onChange={this.onChangeCarrierValue.bind(this, 'defaultTTEmailAddress')}
                        />

                        {settings.defaultTTEmailAddress === 'custom' &&
                            <Input
                                label='Emailadres'
                                value={settings.customDefaultTTEmailAddress}
                                onChange={this.onChangeCarrierValue.bind(this, 'customDefaultTTEmailAddress')}
                            />
                        }

                        <Select
                            label='Aangetekend aanmelden als'
                            options={[
                                {value: '3089', title: '3089 Handtekening voor ontvangst, Alleen huisadres'},
                                {value: '1020', title: '1020 Aangetekend pakket'}
                            ]}
                            value={settings.signedParcelProductCode || '1020'}
                            onChange={this.onChangeCarrierValue.bind(this, 'signedParcelProductCode')}
                        />

                        <Select
                            label='Aangetekende brief aanmelden als'
                            options={[
                                {value: '1010', title: '1010 Aangetekende brief'},
                                {value: '1410', title: '1410 Aangetekende brief partijenpost'},
                                {value: '3089', title: '3089 Handtekening voor ontvangst, Alleen huisadres'}
                            ]}
                            value={settings.signedLetterProductCode || '1010'}
                            onChange={this.onChangeCarrierValue.bind(this, 'signedLetterProductCode')}
                        />

                        <Select
                            label='Brievenbuspakket buitenland aanmelden als'
                            options={[
                                {value: '6350', title: '6350 Packet Track & Trace'},
                                {value: '6972', title: '6972 Boxable Track & Trace'}
                            ]}
                            value={settings.mailboxAbroadProductCode || '6350'}
                            onChange={this.onChangeCarrierValue.bind(this, 'mailboxAbroadProductCode')}
                        />

                        <Select
                            label='Buitenland zendingen binnen EU'
                            options={[
                                {value: '', title: 'Niet standaard verzekerd'},
                                {value: 'trackTraceInsured', title: 'Track & trace Verzekerd'},
                                {value: 'trackTraceInsuredPlus', title: 'Track & trace Verzekerd Plus'}
                            ]}
                            value={settings.foreignInsuranceType || ''}
                            onChange={this.onChangeCarrierValue.bind(this, 'foreignInsuranceType')}
                        />

                        <Select
                            label='Buitenland zendingen buiten EU'
                            options={[
                                {value: '', title: 'Niet standaard verzekerd'},
                                {value: 'trackTraceInsured', title: 'Track & trace Verzekerd'},
                                {value: 'trackTraceInsuredPlus', title: 'Track & trace Verzekerd Plus'}
                            ]}
                            value={settings.foreignNonEUInsuranceType || ''}
                            onChange={this.onChangeCarrierValue.bind(this, 'foreignNonEUInsuranceType')}
                        />

                        {!reseller.isShop &&
                            <Toggle
                                label={`Retouren via ${reseller.settings?.accountName || reseller.name}`}
                                info={`Het adres van ${reseller.settings?.accountName || reseller.name} wordt gebruikt als afzender op de verzendlabels.`}
                                checked={settings.returnsViaReseller}
                                onChange={this.onChangeCarrierChecked.bind(this, 'returnsViaReseller')}
                            />
                        }
                    </FormStack>
                }

                {carrierName === 'Skynet' && !reseller.isShop &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label={`Retouren via ${reseller.settings?.accountName || reseller.name}`}
                            info={`Het adres van ${reseller.settings?.accountName || reseller.name} wordt gebruikt als afzender op de verzendlabels.`}
                            checked={settings.returnsViaReseller}
                            onChange={this.onChangeCarrierChecked.bind(this, 'returnsViaReseller')}
                        />
                    </FormStack>
                }

                {carrierName === 'GLS' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Select
                            label='Standaard emailadres Track & Trace emails'
                            info='Voor GLS zendingen is het meesturen van een emailadres verplicht. Als een zending geen emailadres heeft wordt de gekozen optie gebruikt.'
                            allowEmpty
                            options={[
                                {value: 'resellerEmail', title: reseller.settings.companyAddress.email},
                                {value: 'customerEmail', title: 'Emailadres klant'},
                                {value: 'custom', title: 'Anders'}
                            ]}
                            value={settings.defaultTTEmailAddress}
                            onChange={this.onChangeCarrierValue.bind(this, 'defaultTTEmailAddress')}
                        />

                        {settings.defaultTTEmailAddress === 'custom' &&
                            <Input
                                label='Emailadres'
                                value={settings.customDefaultTTEmailAddress}
                                onChange={this.onChangeCarrierValue.bind(this, 'customDefaultTTEmailAddress')}
                            />
                        }

                        <Toggle
                            label='Gebruik Economy Parcel als standaard'
                            checked={settings.useEconomyParcel}
                            onChange={this.onChangeCarrierChecked.bind(this, 'useEconomyParcel')}
                        />

                        <Toggle
                            label='Zaterdagbezorging'
                            info='Zendingen die op vrijdag worden aangemeld worden op zaterdag bezorgd. Deze instelling kan op klant niveau worden overschreven.'
                            checked={settings.glsSaturdayDelivery}
                            onChange={this.onChangeCarrierChecked.bind(this, 'glsSaturdayDelivery')}
                        />

                        {!reseller.isShop &&
                            <Toggle
                                label={`Retouren via ${reseller.settings?.accountName || reseller.name}`}
                                info={`Het adres van ${reseller.settings?.accountName || reseller.name} gebruikt als afzender op de verzendlabels.`}
                                checked={settings.returnsViaReseller}
                                onChange={this.onChangeCarrierChecked.bind(this, 'returnsViaReseller')}
                            />
                        }
                    </FormStack>
                }

                {carrierName === 'PostNL-MSG' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Aangetekend optie activeren'
                            info={'De optie \'Aangetekend\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                        />
                        <Toggle
                            label='Aangetekende brief optie activeren'
                            info={'De optie \'Aangetekende brief\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedLetterEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedLetterEnabled')}
                        />

                        <Input
                            label='Standaard product SKU'
                            info='Vul hier de SKU code in zoals in het Monta account is gedefineerd.'
                            value={settings.defaultProductSKU}
                            onChange={this.onChangeCarrierValue.bind(this, 'defaultProductSKU')}
                        />

                        <Input
                            label='Brievenbuspakket product SKU'
                            info='Vul hier de SKU code in zoals in het Monta account is gedefineerd.'
                            value={settings.mailboxProductSKU}
                            onChange={this.onChangeCarrierValue.bind(this, 'mailboxProductSKU')}
                        />
                    </FormStack>
                }

                {carrierName === 'DHL-QLS' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Bedrijfsadressen via DHL Europlus'
                            info='Zendingen naar bedrijfsadressen worden verstuurd via het DHL Europlus netwerk. Deze instelling kan op klant niveau worden overschreven.'
                            checked={settings.europlusForBusinesAddress}
                            onChange={this.onChangeCarrierChecked.bind(this, 'europlusForBusinesAddress')}
                        />

                        <Toggle
                            label='Aangetekend optie activeren'
                            info={'De optie \'Aangetekend\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                        />
                    </FormStack>
                }

                {carrierName === 'PostNL-QLS' &&
                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Toggle
                            label='Aangetekend optie activeren'
                            info={'De optie \'Aangetekend\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedEnabled')}
                        />

                        <Toggle
                            label='Aangetekende brief optie activeren'
                            info={'De optie \'Aangetekende brief\' wordt voor deze vervoerder aangemeld als combinatie van de opties \'Handtekening voor ontvangst\' en \'Niet bij buren\'.'}
                            checked={settings.signedLetterEnabled}
                            onChange={this.onChangeCarrierChecked.bind(this, 'signedLetterEnabled')}
                        />
                    </FormStack>
                }

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Crediteurnummer'
                        info='Crediteurnummer dat wordt gebruikt in je boekhouding voor deze vervoerder'
                        value={settings.creditorCode}
                        onChange={this.onChangeCarrierValue.bind(this, 'creditorCode')}
                    />

                    {reseller.settings.administration.api === 'WeFact' && reseller.settings.administration.mergeParcels === 'carrier' &&
                        <Input
                            label='Productnummer'
                            info='Productnummer voor zendingen van deze vervoerder in WeFact.'
                            value={settings.productCode}
                            onChange={this.onChangeCarrierValue.bind(this, 'productCode')}
                        />
                    }
                </FormStack>

                <div style={{display: 'flex', justifyContent: 'flex-end', columnGap: formSpacing.columnGap, marginTop: 90}}>
                    {settings.enabled &&
                        <Button variant='error' onClick={this.onDisable.bind(this, !!platform)}>
                            Deactiveer
                        </Button>
                    }

                    <div style={{flex: 1}} />

                    <Button variant='text' onClick={platform ? () => this.onSubmit(undefined, false, true, 'close') : this.close.bind(this)}>
                        Annuleer
                    </Button>

                    <Button onClick={this.onSubmit.bind(this)}>
                        {settings.enabled || platform ? 'Opslaan' : 'Activeer'}
                    </Button>
                </div>
                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}
